import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useCart } from '@/context/CartContext';
import { useLanguage } from '@/i18n/LanguageContext';

export const ShippingAddressForm = () => {
  const { shippingAddress, setShippingAddress } = useCart();
  const { t } = useLanguage();

  const update = (field) => (e) => setShippingAddress({ ...shippingAddress, [field]: e.target.value });

  return (
    <Card className="bg-card border-border">
      <CardContent className="p-5 space-y-4">
        <p className="text-xs text-muted-foreground">{t('prints.shippingRequired')}</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <Label className="text-xs">{t('prints.name')}</Label>
            <Input value={shippingAddress.name} onChange={update('name')} className="bg-secondary border-border mt-1" data-testid="shipping-name" />
          </div>
          <div>
            <Label className="text-xs">{t('prints.street')}</Label>
            <Input value={shippingAddress.street} onChange={update('street')} className="bg-secondary border-border mt-1" data-testid="shipping-street" />
          </div>
          <div>
            <Label className="text-xs">{t('prints.postalCode')}</Label>
            <Input value={shippingAddress.postal_code} onChange={update('postal_code')} className="bg-secondary border-border mt-1" data-testid="shipping-postal" />
          </div>
          <div>
            <Label className="text-xs">{t('prints.city')}</Label>
            <Input value={shippingAddress.city} onChange={update('city')} className="bg-secondary border-border mt-1" data-testid="shipping-city" />
          </div>
          <div className="sm:col-span-2">
            <Label className="text-xs">{t('prints.country')}</Label>
            <Input value={shippingAddress.country} onChange={update('country')} className="bg-secondary border-border mt-1" data-testid="shipping-country" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
